/**
 * Resolve schema-step blocks. Canonical key is `section`.
 * Legacy fallback: `sections` only when `section` is missing.
 * (PRODUCT nested subsections are unrelated — do not use this for those.)
 */

export function getStepSections(stepSchema) {
  if (!stepSchema || typeof stepSchema !== "object") return [];

  if (Array.isArray(stepSchema.section)) {
    return stepSchema.section;
  }
  if (Array.isArray(stepSchema.sections)) {
    return stepSchema.sections;
  }
  return [];
}

export function getStepSectionsForPopup(popupData, activeStep) {
  const stepIndex =
    typeof activeStep === "number" && !Number.isNaN(activeStep) ? activeStep : 0;
  return getStepSections(popupData?.schema?.[stepIndex]);
}

/** Shell uses maxDimensions + widthUnit; raw width/height on customCSS are not valid React px values. */
export function stripShellDimensionsFromCustomCSS(customCSS) {
  if (!customCSS || typeof customCSS !== "object") return {};
  const { width, height, widthUnit, heightUnit, ...rest } = customCSS;
  return rest;
}

export function parseDimensionValue(value) {
  if (value == null || value === "") return 0;
  if (typeof value === "number" && Number.isFinite(value)) return value;
  const str = String(value).trim();
  const match = str.match(/^([\d.]+)\s*(%|px)?$/i);
  if (!match) return Number(str) || 0;
  const num = Number(match[1]);
  if (!Number.isFinite(num)) return 0;
  if ((match[2] || "").toLowerCase() === "%") return num;
  return num;
}

/** Bounding box from absolutely positioned blocks (so left-side buttons are not clipped). */
export function computeStepContentBounds(sections, isMobile) {
  const view = isMobile ? "mobile" : "desktop";
  let maxRight = 0;
  let maxBottom = 0;

  for (const block of sections) {
    const pos = block?.setting?.position?.displacement?.[view] ?? { x: 0, y: 0 };
    const dim = block?.setting?.dimension?.[view] ?? { width: 0, height: 0 };
    maxRight = Math.max(
      maxRight,
      (Number(pos.x) || 0) + parseDimensionValue(dim.width)
    );
    maxBottom = Math.max(
      maxBottom,
      (Number(pos.y) || 0) + parseDimensionValue(dim.height)
    );
  }

  return { width: maxRight, height: maxBottom };
}
